<form class="container" (submit)="submit($event)">
  <div class="celo-dialog-header">
    <h2 mat-dialog-title class="title">Tell us how we can improve</h2>
    <button
      mat-icon-button
      type="button"
      aria-label="Close"
      class="close celo-dialog-close"
      mat-dialog-close
      [disabled]="isSubmitting"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <label for="g2-review-feedback" class="visually-hidden">Feedback</label>
  <textarea
    id="g2-review-feedback"
    class="feedback"
    rows="6"
    placeholder="Your feedback"
    [attr.maxlength]="maxLength"
    [formControl]="feedback"
  ></textarea>

  <div class="actions">
    <button
      mat-button
      type="submit"
      class="celo-primary-button uppercase"
      [disabled]="!canSubmit"
    >
      Submit
    </button>
  </div>
</form>
